// redux/services/educationService/education.Services.js

import { baseApi } from "../baseApi";

export const EducationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE
    createEducation: builder.mutation({
      query: (data) => ({
        url: "/education-create",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Education"],
    }),

    // GET ALL
    getEducation: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
      } = {}) =>
        `/education-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Education", id })),
              { type: "Education", id: "LIST" },
            ]
          : [{ type: "Education", id: "LIST" }],
    }),

    // GET SINGLE
    getSingleEducation: builder.query({
      query: (id) => `/education-view/${id}`,
      providesTags: (result, error, id) => [{ type: "Education", id }],
    }),

    // UPDATE
    updateEducation: builder.mutation({
      query: (data) => ({
        url: "/education-update",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Education", id },
        { type: "Education", id: "LIST" },
      ],
    }),

    // STATUS CHANGE
    changeStatusEducation: builder.mutation({
      query: (id) => ({
        url: `/education-status/${id}`,
        method: "GET",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Education", id },
        { type: "Education", id: "LIST" },
      ],
    }),

    // DELETE
    deleteEducation: builder.mutation({
      query: (data) => {
        const id = typeof data === 'object' ? data.id : data;
        return {
          url: `/education-delete/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: (result, error, data) => {
        const id = typeof data === 'object' ? data.id : data;
        return [
          { type: "Education", id },
          { type: "Education", id: "LIST" },
        ];
      },
    }),

    // GET ALL (without pagination - for dropdowns)
    getAllEducation: builder.query({
      query: () => "/education-all",
      providesTags: ["Education"],
    }),
  }),
});

export const {
  useCreateEducationMutation,
  useGetEducationQuery,
  useGetSingleEducationQuery,
  useUpdateEducationMutation,
  useDeleteEducationMutation,
  useChangeStatusEducationMutation,
  useGetAllEducationQuery,
} = EducationApi;